module.exports = __webpack_public_path__ + "static/img/10.5dafb5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/10.png
// module id = SXE9
// module chunks = 0